import { useEffect } from 'react';
import { useReactFlow } from 'reactflow';

const useSetViewportCenter = () => {
    const { setCenter } = useReactFlow();

    useEffect(() => {
        setCenter(0, 0, { zoom: 1 });
    }, [setCenter]);
};

export { useSetViewportCenter };
